export const StateMaster = [
  {
    key: 'TX',
    label: 'Texas',
    value: 'TX',
  },
  {
    key: 'WI',
    label: 'Wisconsin',
    value: 'WI',
  },
  {
    key: 'VA',
    label: 'Virginia',
    value: 'VA',
  },
  {
    key: 'LA',
    label: 'Louisiana',
    value: 'LA',
  },
  {
    key: 'MS',
    label: 'Mississippi',
    value: 'MS',
  },
  {
    key: 'IL',
    label: 'Illinois',
    value: 'IL',
  },
  {
    key: 'GA',
    label: 'Georgia',
    value: 'GA',
  },
  {
    key: 'PA',
    label: 'Pennsylvania',
    value: 'PA',
  },
  {
    key: 'FL',
    label: 'Florida',
    value: 'FL',
  },
  {
    key: 'SC',
    label: 'South Carolina',
    value: 'SC',
  },
  {
    key: 'MD',
    label: 'Maryland',
    value: 'MD',
  },
  {
    key: 'OK',
    label: 'Oklahoma',
    value: 'OK',
  },
  {
    key: 'CO',
    label: 'Colorado',
    value: 'CO',
  },
  {
    key: 'CT',
    label: 'Connecticut',
    value: 'CT',
  },
  {
    key: 'ME',
    label: 'Maine',
    value: 'ME',
  },
  {
    key: 'AZ',
    label: 'Arizona',
    value: 'AZ',
  },
  {
    key: 'CA',
    label: 'California',
    value: 'CA',
  },
  {
    key: 'NC',
    label: 'North Carolina',
    value: 'NC',
  },
  {
    key: 'MI',
    label: 'Michigan',
    value: 'MI',
  },
  {
    key: 'OH',
    label: 'Ohio',
    value: 'OH',
  },
  {
    key: 'NJ',
    label: 'New Jersey',
    value: 'NJ',
  },
];
